import { render } from "./TabControl.vue?vue&type=template&id=3d843c12&scoped=true"
import script from "./TabControl.vue?vue&type=script&lang=js"
export * from "./TabControl.vue?vue&type=script&lang=js"

import "./TabControl.vue?vue&type=style&index=0&id=3d843c12&scoped=true&lang=scss"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d843c12"]])

export default __exports__